import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { initialBalancesApi } from 'src/Services/API';
import { InitialBalanceDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

const useFetchInitialBalances = () => {
  const assetId = useCurrentAssetId();

  return useQuery<InitialBalanceDto[], AxiosError<ApiError>>({
    queryKey: ['fetch-initial-balances', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await initialBalancesApi.initialBalancesControllerFindAll(assetId)).data;
    },
    enabled: !!assetId,
  });
};

export default useFetchInitialBalances;
